export const Id_Tipo_tutoria = 82; 
export const Id_Estado_tutoria = 81; 
export const Id_Carreras_CUC = 5;
export const Id_secundario_generica = 30;
